//#region src/utils/escape.ts
var e = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#x27;",
	"`": "&#x60;",
	"=": "&#x3D;"
}, t = /[&<>"'`=]/, n = /[&<>"'`=]/g;
function r(t) {
	return e[t];
}
function i(e) {
	let i;
	if (typeof e != "string") {
		if (e == null) return "";
		if (!e) return String(e);
		i = String(e);
	} else i = e;
	return t.test(i) ? i.replace(n, r) : i;
}
//#endregion
export { i as escape };
